module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/mv_sp-6120bac864da2d9e6ccfd8fa2f1fb756.png";